/**
 * Legacy module — preserved as an empty module so existing dependencies
 * (`acme.common.service.membership`) keep resolving.
 *
 * The real implementation lives at:
 *   apps/b2b-frontend/app/core/membership/membership.service.ts
 *
 * It's registered with AngularJS in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 * via downgradeInjectable, so any `$inject = ['MembershipService']` resolves
 * to the Angular 18 class. Wave 3 item #28.
 */
angular.module('acme.common.service.membership', [
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.permissions',
]);
